import { createAction, props } from '@ngrx/store';
import { SafeAttachmentPolicy } from './model';

export const loadSafeAttachmentPolicy = createAction(
    '[Client/Pwsh/Exo] Load SafeAttachmentPolicy',
    props<{ _tenant: string }>(),
);

export const loadSafeAttachmentPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Load SafeAttachmentPolicy Success',
    props<{ _tenant: string; data: SafeAttachmentPolicy[] }>(),
);

export const loadSafeAttachmentPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Load SafeAttachmentPolicy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const createExoSafeAttachmentPolicy = createAction(
    '[Client/Pwsh/Exo] Create SafeAttachmentPolicy',
    props<{ _tenant: string; data: Partial<SafeAttachmentPolicy> }>(),
);

export const createExoSafeAttachmentPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Create SafeAttachmentPolicy Success',
    props<{ _tenant: string; data: SafeAttachmentPolicy }>(),
);

export const createExoSafeAttachmentPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Create SafeAttachmentPolicy Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateExoSafeAttachmentPolicy = createAction(
    '[Client/Pwsh/Exo] Update SafeAttachmentPolicy',
    props<{ _tenant: string; data: Partial<SafeAttachmentPolicy> }>(),
);

export const updateExoSafeAttachmentPolicySuccess = createAction(
    '[Client/Pwsh/Exo] Update SafeAttachmentPolicy Success',
    props<{ _tenant: string; data: SafeAttachmentPolicy }>(),
);

export const updateExoSafeAttachmentPolicyFailure = createAction(
    '[Client/Pwsh/Exo] Update SafeAttachmentPolicy Failure',
    props<{ _tenant: string; error: any }>(),
);
